import type { ReactElement, ReactNode, TextareaHTMLAttributes } from 'react';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import TextArea from 'components/TextArea/TextArea';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

type FormInputPropsT<FormValuesT> = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  name: Path<FormValuesT> | string;
  label?: string | ReactNode;
  isRequired?: boolean;
};

const FormTextArea = <FormValuesT,>({
  name,
  ...restProps
}: FormInputPropsT<FormValuesT>): ReactElement => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <TextArea {...register(name)} {...restProps} />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormTextArea;
